import { QueryObserver } from '@tanstack/react-query';
import { assign, sendParent } from 'xstate';
import { paymentEnterpriseEligibilityCacheKey, queryFnFactory } from '@syf-api-library/payment-enterprise-eligibility';
import { constructEligibilityQueryParams } from '../helpers';
import fetchMachine from './fetchMachine';
const ASSIGN_ACTION = assign({
    paymentEnterpriseEligibilityQueryResult: ({ paymentEnterpriseEligibilityQueryResult }, event) => {
        const [, data] = event.data;
        return Object.assign(Object.assign({}, paymentEnterpriseEligibilityQueryResult), { data });
    }
});
export const sendEligibilitySuccessToParent = sendParent((context, event) => {
    return Object.assign(Object.assign({}, event), { type: 'AFTER_ELIGIBILITY_FETCH' });
});
const paymentEnterpriseEligibility = {
    type: 'parallel',
    states: {
        querySubscription: {
            invoke: {
                src: ({ apiConfig, queryClient, featureFlags }) => {
                    const queryKey = paymentEnterpriseEligibilityCacheKey(apiConfig.keyProps);
                    const queryObserver = new QueryObserver(queryClient, {
                        queryKey,
                        queryFn: queryFnFactory(Object.assign(Object.assign({}, apiConfig.config), { eligibilityTypes: constructEligibilityQueryParams(featureFlags) }), apiConfig.keyProps),
                        enabled: false
                    });
                    const subscribe = (next) => {
                        const unsubscribe = queryObserver.subscribe((event) => {
                            if (event.isLoading === false && event.isSuccess === true) {
                                const data = [queryKey, event.data];
                                next({ type: 'SET_PAYMENT_ELIGIBILITY', data });
                            }
                        });
                        return {
                            unsubscribe
                        };
                    };
                    return {
                        subscribe
                    };
                }
            }
        },
        api: {
            initial: 'idle',
            states: {
                idle: {},
                fetching: {
                    invoke: {
                        src: fetchMachine,
                        data: {
                            // initialize fetchMachine with context values
                            cacheKey: ({ apiConfig }) => paymentEnterpriseEligibilityCacheKey(apiConfig.keyProps),
                            queryClient: ({ queryClient }) => queryClient,
                            queryFn: ({ apiConfig, featureFlags }) => queryFnFactory(Object.assign(Object.assign({}, apiConfig.config), { eligibilityTypes: constructEligibilityQueryParams(featureFlags) }), apiConfig.keyProps)
                        },
                        onDone: {
                            target: 'success',
                            actions: ASSIGN_ACTION
                        },
                        onError: {
                            target: 'error',
                            actions: assign({
                                paymentEnterpriseEligibilityQueryResult: ({ paymentEnterpriseEligibilityQueryResult }, event) => {
                                    const [, error] = event.data;
                                    return Object.assign(Object.assign({}, paymentEnterpriseEligibilityQueryResult), { error });
                                }
                            })
                        }
                    },
                    on: {
                        FETCH_PAYMENT_ELIGIBILITY: undefined
                    }
                },
                success: {
                    entry: 'sendEligibilitySuccessToParent'
                },
                error: {
                    entry: 'sendErrorToParent'
                }
            }
        }
    },
    on: {
        FETCH_PAYMENT_ELIGIBILITY: {
            target: '#apiMachine.paymentEnterpriseEligibility.api.fetching',
            actions: ({ apiConfig, queryClient }, { force }) => {
                if (force) {
                    queryClient.invalidateQueries(paymentEnterpriseEligibilityCacheKey(apiConfig.keyProps));
                }
            }
        },
        SET_PAYMENT_ELIGIBILITY: {
            target: '#apiMachine.paymentEnterpriseEligibility.api.success',
            actions: ASSIGN_ACTION
        }
    }
};
export default paymentEnterpriseEligibility;
